import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  saveCarnival,
  getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import {getExistingProjectList, createProjectOnboarding} from 'services/redux/sales/projectOnboarding/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import OnboardProject from './onboardProject';

import { LeadSource, getApartmentDropDown } from "services/redux/sales/corporate/leadDetails/action";
import {
  pocSiteType,
  pocSubSiteType,
  pocType,
} from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  getSupplyDropDown,
  rwaTenureFun,
  getCorporateDropDown,
  supplyNameFun,
} from "services/redux/sales/corporate/categoryDetails/action";
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { createSupplyLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { createApartmentLead } from "services/redux/sales/corporate/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { BulkUploadLead, getSampleFileLead } from "services/redux/sales/importLead/action";

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  leadInfraId: state.ConductCampReducer.leadInfraId,
  existingProjectList: state.projectOnboardingReducer.existingProjectList,
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  pocSiteTypeData: state.pocTypesReducer.pocSiteTypeData,
  pocSubSiteTypeData: state.pocTypesReducer.pocSubSiteTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  supDropDownData: state.categoryDetlReducer.supDropDownData,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  sampleData: state.importReducer.sampleData,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  rwaTenureData: state.categoryDetlReducer.rwaTenureData,
  appartmentDropDown: state.LeadDetailsReducer.appartmentDropDown,
  corDropDownData: state.categoryDetlReducer.corDropDownData,
  splNameData: state.categoryDetlReducer.splNameData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getLeadInfraId,
      saveCarnival,
      getExistingProjectList,LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      getCorporateDropDown,
      locationPinCode,
      locationState,
      createSupplyLead,
      pocSiteType,
      pocSubSiteType,
      getSupplyDropDown,
      createApartmentLead,
      rwaTenureFun,
      getApartmentDropDown,
      getCurrentLocation,
      excelUploadUrl,
      BulkUploadLead,
      getSampleFileLead,
      createProjectOnboarding,
      supplyNameFun,
      documentUploadUrl
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(OnboardProject);
